/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';

import './SquareButton.css';

const getClassNames = (props) => {
  const {
    color, disabled, className, test,
  } = props;
  return classNames({
    button: true,
    [`button-${color}`]: true,
    disabled,
    [className]: className,
    [test]: test,
  });
};

const SquareButton = ({
  id,
  onClick,
  color,
  icon,
  text,
  disabled,
  className,
  styles,
  test,
}) => (
  <div className="square-button">
    <button
      id={id}
      className={getClassNames({ color, disabled, className })}
      onClick={onClick}
      disabled={disabled}
      test={test}
      style={{ ...styles }}
    >
      {icon && <FontAwesome icon={icon} />}
      {text}
    </button>
  </div>
);

SquareButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  styles: PropTypes.object,
  test: PropTypes.string,
  id: PropTypes.string,
};

SquareButton.defaultProps = {
  onClick: () => {},
  color: 'green',
  icon: '',
  disabled: false,
  className: '',
  styles: {},
  test: null,
  id: null,
};
export default SquareButton;
